import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import img1 from "../assets/sushi_splash.webp";
import img2 from "../assets/space_powerup.webp";
import img3 from "../assets/wreck_bounce.webp";
import img4 from "../assets/puzzle_game.webp";

import img5 from "../assets/summoners_trials.webp";
import img6 from "../assets/The_Witches_Box.webp";
import img7 from "../assets/bean_boy_bouncin.webp";
import img8 from "../assets/claude_oculos.webp";
import img9 from "../assets/rogues_kingdom.webp";

const cards = [
    { img: img1, title: "Sushi Splash", desc: "Catch flying fish before they escape - and don't fall off the boat!" },
    { img: img2, title: "Space Powerup", desc: "Blast space rubble from the cockpit and feel like a real pilot." },
    { img: img3, title: "Wreck Bounce", desc: "Classic brick-breaking fun - but made extra friendly and bouncy." },
    { img: img4, title: "Kiddy Puzzle", desc: "Drag, match, and giggle - simple touchscreen puzzle fun for little kids." },

    { img: img5, title: "Summoners Trials", desc: "Call forth mighty creatures and outsmart chaos in this fast-paced summoning roguelike." }, // Placeholder
    { img: img6, title: "The Witches Box", desc: "A knight, a cursed room, and a witch who won't play fair - how long can you survive?" }, // Placeholder
    { img: img7, title: "Bean Boy Bouncin", desc: "Bounce, blast, and boing your way through chaos as the unstoppable Bean Boy!" }, // Placeholder
    { img: img8, title: "Claude Oculos", desc: "Drag, match, and giggle - simple touchscreen puzzle fun for little kids." }, // Placeholder
    { img: img9, title: "Rogues Kingdom", desc: "A haunting game of sound and silence - escape the blind rabbit before it finds you." }, // Placeholder

];

export default function Projects() {
    return (
        <section className="projects">
            <h1 data-translate="OurProjectsTitle" className="fadeOnScroll">OUR PROJECTS</h1>
            <Swiper
                modules={[Autoplay]}
                slidesPerView={4}
                spaceBetween={20}
                loop={true}
                speed={12000}
                autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                }}
                centeredSlides={false}
                allowTouchMove={true}
                grabCursor={false}
                loopedSlides={cards.length}
                className="projectsSwiper"
                breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1200: { slidesPerView: 3 },
                    1500: { slidesPerView: 4 },
                }}>

                {[...cards, ...cards].map((card, i) => (
                    <SwiperSlide key={i}>
                        <div className="projectCard">
                            <img src={card.img} alt={card.title} />
                            <h2>{card.title}</h2>
                            <p
                                data-translate={`OP_${card.title.replace(/\s+/g, '').toLowerCase()}`}
                            >
                                {card.desc}
                            </p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

        </section>
    );
}
